/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsbyprofile2Inputs */

const en_earningsbyprofile2 = /** @type {(inputs: Earningsbyprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By profile`)
};

const de_earningsbyprofile2 = /** @type {(inputs: Earningsbyprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Profil`)
};

/**
* | output |
* | --- |
* | "By profile" |
*
* @param {Earningsbyprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsbyprofile2 = /** @type {((inputs?: Earningsbyprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsbyprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsbyprofile2(inputs)
	return de_earningsbyprofile2(inputs)
});
export { earningsbyprofile2 as "earningsByProfile" }